'use strict';

var index = (function (initialState) {
    return function (triggerType, triggerName, hydrateType, hydrateObjectKey) {
        return function () {
            var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
            var action = arguments[1];

            var _ref = action || {},
                payload = _ref.payload;

            if (hydrateType && action.type === hydrateType) {
                var payloadValue = payload[hydrateObjectKey][triggerName];
                return payloadValue === undefined || payloadValue === null ? state : payloadValue;
            } else if (action.type === triggerType && payload.name === triggerName) {
                return payload.value === null || payload.value === undefined ? initialState : payload.value;
            }

            return state;
        };
    };
});

module.exports = index;
